'use client'
import FileUpload from "../components/fileUpload/fileUpload";
import WelcomeSkeleton from "../components/LoadingSkeletons/welcomeSkeleton";
import ProtectedRoute from "../components/ProtectedRoute";

const SupplierUpload = () => {
    return <ProtectedRoute
        requiredRole="supplier"
        loadingScreen={<WelcomeSkeleton />}
        redirectTo='/product-supplier'>
        <FileUpload />
    </ProtectedRoute>
}

export default SupplierUpload;